// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"2c928f27","114":"4c97e6f2","210":"bf4b9e95","265":"bf4b9e95","343":"e6b7cc9a","522":"1680c42d","762":"7713ab84"}[chunkId] + ".chunk.css";
};